/**
 * Что можно пускать в `href`.
 *
 * Опасность здесь одна и та же в любом поле: `javascript:` и `data:` в ссылке
 * выполняют код в браузере того, кто по ней щёлкнул. React такие ссылки сейчас
 * гасит сам, и браузеры запрещают переход на `data:` верхнего уровня, — но
 * держать защиту на чужом уровне нельзя: поле заполняет человек, и правило
 * должно стоять там же, где остальные правила ввода.
 *
 * Проверка живёт отдельно от схем, потому что нужна двум разным полям — ссылке
 * в блоке обучения и ссылке в согласии. Две копии одного правила разъезжаются
 * молча: так и вышло, что у одного поля проверка была, а у другого нет.
 */

/** Внешний адрес: только http и https. */
export function isHttpUrl(value: string): boolean {
  try {
    const { protocol } = new URL(value);
    return protocol === 'http:' || protocol === 'https:';
  } catch {
    return false;
  }
}

/**
 * Свой путь на этой же площадке: загруженный файл или подготовленная графика.
 *
 * Двойной слэш при этом чужой: «//example.com» браузер читает как внешний
 * адрес, а «/\example.com» — некоторые разборщики тоже. Свой путь — тот, что
 * начинается ровно с одного слэша.
 */
export function isOwnPath(value: string): boolean {
  return value.startsWith('/') && !value.startsWith('//') && !value.startsWith('/\\');
}
